<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          KEY HIGHLIGHT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Message Detail
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="search" @click="getData()" title="refresh">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <v-flex xs12 class="pa-7">
          <v-layout row wrap>
            <table width="100%">
              <tr>
                <td width="9%">Start Date</td>
                <td width="2%">:</td>
                <td class="grey--text">{{ item.start }}</td>
              </tr>
              <tr>
                <td>End Date</td>
                <td>:</td>
                <td class="grey--text">
                  {{ item.end }}
                </td>
              </tr>
              <tr>
                <td>Message</td>
                <td>:</td>
                <td class="grey--text">
                  {{ item.message }}
                </td>
              </tr>
              <tr>
                <td>Receiver</td>
                <td>:</td>
                <td v-if="item.type === 'POSITIONS'" class="grey--text">
                  <v-chip
                    v-for="(val, index) in item.positionsChecklist"
                    :key="index"
                    class="mt-1 mr-2 mb-2"
                  >
                    {{ val.position }}
                  </v-chip>
                </td>
                <td class="grey--text" style="white-space: pre-line;" v-else>
                  <v-chip
                    v-for="(val, index) in item.profilesChecklist"
                    :key="index"
                    class="mt-1 mr-2 mb-2"
                  >
                    {{ val.desc }}
                  </v-chip>
                </td>
              </tr>
            </table>
          </v-layout>
        </v-flex>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 right class="mr-4">
            <v-btn
              id="btn-back"
              dark
              rounded
              color="red"
              block
              :to="{ name: 'keyHighlight' }"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ProgressDialog from '../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import moment from 'moment';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Message List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Message Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      item: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('keyHighlight/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.item = data.data;
            this.item.start = moment(data.data.start).format('DD MMM YYYY');
            this.item.end = moment(data.data.end).format('DD MMM YYYY');
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
